export { Vocabulary } from './Vocabulary';
export { LEXICAL, SEMANTIC, WILDCARD } from './DictionaryConstants';
